/* UNTIL BLACK — theme script (vanilla JS, no dependencies).
   Data comes from Liquid (JSON <script> tags); cart actions use Shopify's /cart/add.js. */
(() => {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const UB = window.UB || {};
  const fmtOpts = (d) => ({ style: "currency", currency: UB.currency || "CHF", minimumFractionDigits: d, maximumFractionDigits: d });
  const fmt0 = new Intl.NumberFormat(UB.locale || "en", fmtOpts(0)), fmt2 = new Intl.NumberFormat(UB.locale || "en", fmtOpts(2));
  const money = (cents) => { cents = Math.round(cents); return (cents % 100 ? fmt2 : fmt0).format(cents / 100); };
  const readJSON = (id) => { const el = document.getElementById(id); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };

  /* ------------------------------------------------------------ cart */
  function toast(msg) {
    const t = $("#toast"); if (!t) return;
    t.textContent = msg; t.classList.add("is-visible");
    clearTimeout(toast._t); toast._t = setTimeout(() => t.classList.remove("is-visible"), 2600);
  }
  async function refreshCount() {
    try {
      const cart = await (await fetch((UB.routes.root || "/") + "cart.js", { headers: { Accept: "application/json" } })).json();
      const c = $("#cart-count"); if (c) { c.textContent = cart.item_count; c.classList.add("bump"); setTimeout(() => c.classList.remove("bump"), 400); }
    } catch (e) {}
  }
  async function addItems(items, label) {
    const res = await fetch(UB.routes.cartAdd + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) { toast(data.description || data.message || "Couldn’t add to cart"); return false; }
    await refreshCount();
    toast(`Added: ${label}`);
    return true;
  }

  /* ------------------------------------------------------------ chrome */
  function initChrome() {
    const burger = $("#burger"), menu = $("#menu");
    if (burger && menu) {
      burger.addEventListener("click", () => {
        const open = burger.getAttribute("aria-expanded") !== "true";
        burger.setAttribute("aria-expanded", String(open));
        menu.classList.toggle("is-open", open);
        menu.setAttribute("aria-hidden", String(!open));
        document.body.classList.toggle("no-scroll", open);
      });
      $$("#menu a").forEach((a) => a.addEventListener("click", () => burger.getAttribute("aria-expanded") === "true" && burger.click()));
    }
    const header = $("#header");
    if (header) { const f = () => header.classList.toggle("is-scrolled", window.scrollY > 20); window.addEventListener("scroll", f, { passive: true }); f(); }
    const title = $("#hero-title");
    if (title) requestAnimationFrame(() => setTimeout(() => title.classList.add("is-in"), 120));
    if (!reduceMotion && window.matchMedia("(pointer: fine)").matches) {
      $$(".magnetic").forEach((el) => {
        el.addEventListener("pointermove", (e) => { const r = el.getBoundingClientRect(); el.style.transform = `translate(${(e.clientX - r.left - r.width / 2) * 0.18}px, ${(e.clientY - r.top - r.height / 2) * 0.3}px)`; });
        el.addEventListener("pointerleave", () => { el.style.transform = ""; });
      });
    }
    const svg = $("#tally");
    if (svg) {
      const build = () => {
        const w = svg.clientWidth, h = svg.clientHeight, gw = 70, gh = 80; let out = "", i = 0;
        for (let r = 0; r < Math.ceil(h / gh); r++) for (let c = 0; c < Math.ceil(w / gw); c++) {
          if (Math.random() < 0.35) continue;
          const x = c * gw + 14, y = r * gh + 20, rot = (Math.random() - 0.5) * 6, delay = reduceMotion ? 0 : (i++ * 0.012).toFixed(3);
          let d = ""; for (let k = 0; k < 4; k++) d += `M${x + k * 9} ${y} l${((Math.random() - .5) * 2).toFixed(1)} 38 `;
          d += `M${x - 6} ${y + 28} l46 -20`;
          out += `<path pathLength="1" style="animation-delay:${delay}s" transform="rotate(${rot.toFixed(1)} ${x + 14} ${y + 19})" d="${d}"/>`;
        }
        svg.innerHTML = out;
      };
      build(); let t; window.addEventListener("resize", () => { clearTimeout(t); t = setTimeout(build, 300); });
    }
  }
  function initReveal() {
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      const sib = [...e.target.parentElement.children].filter((c) => c.classList.contains("reveal"));
      e.target.style.transitionDelay = `${Math.min(Math.max(sib.indexOf(e.target), 0), 5) * 80}ms`;
      e.target.classList.add("is-in"); io.unobserve(e.target);
    }), { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    $$(".reveal:not(.is-in)").forEach((el) => io.observe(el));
  }

  /* ------------------------------------------------------------ home: designs tabs */
  function initDesigns() {
    const btns = $$(".seg__btn"); if (!btns.length) return;
    const all = $("#designs-all");
    btns.forEach((b) => b.addEventListener("click", () => {
      btns.forEach((x) => { const on = x === b; x.classList.toggle("is-active", on); x.setAttribute("aria-selected", String(on)); });
      $$("[data-panel]").forEach((p) => { const on = p.dataset.panel === b.dataset.cat; p.hidden = !on; if (on) [...p.children].forEach((c, i) => { c.classList.remove("pop"); void c.offsetWidth; c.classList.add("pop"); c.style.animationDelay = `${i * 60}ms`; }); });
      if (all) { all.href = b.dataset.url; all.textContent = `View all ${b.dataset.cat} →`; }
    }));
  }

  /* ------------------------------------------------------------ sliders (kit builder rows) */
  function makeSlider(track) {
    const wrap = document.createElement("div"); wrap.className = "slider";
    track.parentNode.insertBefore(wrap, track); wrap.appendChild(track);
    wrap.insertAdjacentHTML("beforeend", `<button class="slider__btn slider__btn--prev" type="button" aria-label="Scroll left">←</button><button class="slider__btn slider__btn--next" type="button" aria-label="Scroll right">→</button>`);
    const step = () => Math.max(track.clientWidth * 0.8, 160);
    $(".slider__btn--prev", wrap).addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    $(".slider__btn--next", wrap).addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      wrap.classList.toggle("has-overflow", max > 0);
      wrap.classList.toggle("at-start", track.scrollLeft <= 2);
      wrap.classList.toggle("at-end", track.scrollLeft >= max);
    };
    track.addEventListener("scroll", update, { passive: true }); window.addEventListener("resize", update); update();
    let down = false, startX = 0, startL = 0, moved = false;
    track.addEventListener("pointerdown", (e) => { if (e.pointerType !== "mouse") return; down = true; moved = false; startX = e.clientX; startL = track.scrollLeft; });
    window.addEventListener("pointermove", (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 5) { moved = true; track.classList.add("is-dragging"); } if (moved) track.scrollLeft = startL - dx; });
    window.addEventListener("pointerup", () => { down = false; track.classList.remove("is-dragging"); });
    track.addEventListener("click", (e) => { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);
  }

  /* ------------------------------------------------------------ home: kit builder */
  function initBuilder() {
    const data = readJSON("builder-data"); if (!data) return;
    const byId = {}; Object.values(data).flat().forEach((p) => { byId[p.id] = p; });
    const state = { tops: null, bottoms: new Set(), gear: new Set(), variant: {} };
    const firstTop = data.tops && data.tops[0], firstBottom = data.bottoms && data.bottoms[0];
    const firstShorts = data.bottoms && data.bottoms.find((p) => !p.spats);
    if (firstTop) state.tops = firstTop.id; if (firstShorts || firstBottom) state.bottoms.add((firstShorts || firstBottom).id);
    const chosen = () => [state.tops, ...state.bottoms, ...state.gear].filter(Boolean).map((id) => byId[id]);
    const sizeIdx = (p) => p.options.findIndex((o) => /size/i.test(o));
    const variantOf = (p) => p.variants.find((v) => v.id === state.variant[p.id])
      || p.variants.find((v) => v.available && sizeIdx(p) > -1 && v.options[sizeIdx(p)] === "M")
      || p.variants.find((v) => v.available) || p.variants[0];
    // pick a value for option i, keep the others, fall back to the closest available variant
    const choose = (p, i, value) => {
      const cur = variantOf(p).options.slice(); cur[i] = value;
      const exact = p.variants.find((v) => v.options.every((o, k) => o === cur[k]) && v.available);
      const near = p.variants.find((v) => v.options[i] === value && v.available);
      if (exact || near) state.variant[p.id] = (exact || near).id;
    };
    const chipsFor = (p) => {
      if (!p.options.length) return "";
      const v = variantOf(p);
      return `<div class="kitopts">${p.options.map((name, i) => {
        const values = [...new Set(p.variants.map((x) => x.options[i]))];
        return `<div class="kitopt"><span class="kitopt__name mono">${name}</span><div class="kitopt__chips" role="group" aria-label="${p.title} ${name}">${values.map((val) => {
          const ok = p.variants.some((x) => x.options[i] === val && x.available);
          const on = v.options[i] === val;
          return `<button type="button" class="kchip${on ? " is-on" : ""}" data-id="${p.id}" data-i="${i}" data-v="${val}" aria-pressed="${on}" ${ok ? "" : "disabled"}>${val}</button>`;
        }).join("")}</div></div>`;
      }).join("")}</div>`;
    };
    const draw = (picked) => {
      $$("#builder .pick").forEach((b) => { const id = Number(b.dataset.id); b.setAttribute("aria-pressed", String(id === state.tops || state.bottoms.has(id) || state.gear.has(id))); });
      if (picked) { picked.classList.remove("just-picked"); void picked.offsetWidth; picked.classList.add("just-picked"); }
      const list = chosen();
      const sum = list.reduce((s, p) => s + variantOf(p).price, 0);
      // same rule as the shop's automatic discounts: 2 pieces 15%, 3 or more 20%
      const n = list.length;
      const pct = n >= 3 ? 0.2 : n === 2 ? 0.15 : 0;
      const now = list.reduce((s, p) => { const c = variantOf(p).price; return s + c - Math.round(c * pct); }, 0); // same per-line rounding as Shopify's automatic discount
      $("#kit-list").innerHTML = list.length ? list.map((p) => `<li class="kitline"><div class="kitline__head"><span>${p.title}</span><span class="mono">${money(variantOf(p).price)}</span></div>${chipsFor(p)}</li>`).join("") : `<li class="muted">Nothing picked yet</li>`;
      $("#kit-was").textContent = pct ? money(sum) : "";
      $("#kit-now").textContent = list.length ? money(pct ? now : sum) : "—";
      $("#kit-save").textContent = pct ? `You save ${money(sum - now)} (${Math.round(pct * 100)}%)` : "Pick 2 pieces to save 15%";
      $("#kit-meter").style.width = `${n >= 3 ? 100 : n === 2 ? 66 : n ? 33 : 0}%`;
      $("#kit-hint").textContent = n >= 3 ? "Max discount unlocked — 20% off" : n === 2 ? "Add spats or gear to unlock 20% off" : "Add one more piece to unlock 15% off";
      $("#kit-add").disabled = !list.length;
    };
    $$("#builder .picker").forEach((pk) => pk.addEventListener("click", (e) => {
      const b = e.target.closest(".pick"); if (!b) return;
      const id = Number(b.dataset.id), g = pk.dataset.group;
      if (g === "gear") state.gear.has(id) ? state.gear.delete(id) : state.gear.add(id);
      else if (g === "bottoms") {
        // one pair of shorts and one pair of spats at most: picking a new one swaps out the same kind
        if (state.bottoms.has(id)) state.bottoms.delete(id);
        else { [...state.bottoms].forEach((x) => { if (byId[x].spats === byId[id].spats) state.bottoms.delete(x); }); state.bottoms.add(id); }
      }
      else state[g] = state[g] === id ? null : id;
      draw(b);
    }));
    $("#kit-list").addEventListener("click", (e) => {
      const c = e.target.closest(".kchip"); if (!c || c.disabled) return;
      const p = byId[Number(c.dataset.id)]; choose(p, Number(c.dataset.i), c.dataset.v); draw();
    });
    $("#kit-add").addEventListener("click", async () => {
      const list = chosen(); if (!list.length) return;
      const btn = $("#kit-add"); btn.disabled = true;
      await addItems(list.map((p) => ({ id: variantOf(p).id, quantity: 1, properties: { _kit: "Kit builder" } })), `Kit (${list.length} pieces)`);
      btn.disabled = false;
    });
    draw();
    $$("#builder .picker").forEach(makeSlider);
  }

  /* ------------------------------------------------------------ product page */
  function initProduct() {
    const data = readJSON("pdp-data"); const form = $("#pdp-form"); if (!data || !form) return;
    const sets = $$("fieldset[data-option]", form);
    const main = $("#g-main");
    const setImage = (src, alt) => {
      if (!main || !src) return;
      main.removeAttribute("srcset"); main.src = src; if (alt) main.alt = alt;
      const base = src.split("?")[0];
      $$("#g-thumbs .thumb").forEach((t) => t.classList.toggle("is-active", t.dataset.src.split("?")[0] === base));
    };
    const current = () => {
      const values = sets.map((fs) => { const c = $("input:checked", fs); return c ? c.value : null; });
      return data.variants.find((v) => v.options.every((o, i) => o === values[i])) || null;
    };
    const update = () => {
      const v = sets.length ? current() : data.variants[0];
      const add = $("#pdp-add");
      if (!v) { add.disabled = true; add.textContent = "Unavailable"; return; }
      $("#pdp-variant").value = v.id;
      $("#pdp-price").textContent = v.price;
      $("#pdp-was").textContent = v.compare || "";
      add.disabled = !v.available; add.textContent = v.available ? `Add to cart — ${v.price}` : "Sold out";
      const st = $("#pdp-stock");
      if (v.qty !== null && v.qty > 0 && v.qty <= 5) {
        st.hidden = false;
        st.innerHTML = `<span class="stock__dot" aria-hidden="true"></span><span class="stock__text"><strong>Last pieces.</strong> Only ${v.qty} left</span><span class="stock__bar" aria-hidden="true"><span style="width:${Math.max(12, v.qty / 5 * 100)}%"></span></span>`;
      } else st.hidden = true;
      // image: variant image, else first image whose alt mentions a selected option (e.g. "long sleeve")
      if (v.image) setImage(v.image);
      else {
        const opts = v.options.map((o) => o.toLowerCase());
        const hit = data.images.find((img) => opts.some((o) => o.length > 2 && img.alt && img.alt.includes(o + " sleeve")));
        if (hit) setImage(hit.src, hit.alt);
      }
      const url = new URL(location.href); url.searchParams.set("variant", v.id); history.replaceState(null, "", url);
    };
    sets.forEach((fs) => fs.addEventListener("change", update));
    const thumbs = $("#g-thumbs");
    if (thumbs) thumbs.addEventListener("click", (e) => {
      const t = e.target.closest(".thumb"); if (!t) return;
      $$(".thumb", thumbs).forEach((x) => x.classList.toggle("is-active", x === t));
      setImage(t.dataset.src, t.dataset.alt);
    });
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const id = Number($("#pdp-variant").value); const add = $("#pdp-add"); add.disabled = true;
      await addItems([{ id, quantity: 1 }], document.querySelector(".pdp__title").textContent.trim());
      add.disabled = false;
    });
    if (sets.length) update();
  }

  /* ------------------------------------------------------------ ranked page */
  const BELTS = [
    { key: "white",  tag: "white belt",  name: "White",  rank: "#f4f4f2", bar: "#111111", text: "#f4f4f2", line: "You’ll tap a thousand times. Good.", time: "1–2 years", total: "Day one", copy: "White and light-grey hex camo. Clean enough for day one, built for a thousand taps." },
    { key: "blue",   tag: "blue belt",   name: "Blue",   rank: "#2f5bd3", bar: "#111111", text: "#4d7bff", line: "The blue belt blues are real. Stay.", time: "2–3 years", total: "~2 years in", copy: "Blue hex texture fading into charcoal. Same cut as the purple, in the color you earned." },
    { key: "purple", tag: "purple belt", name: "Purple", rank: "#6a3fb5", bar: "#111111", text: "#9a6cf0", line: "Now you have a game. Now they hunt you.", time: "1.5–2 years", total: "~4–5 years in", copy: "Purple hex texture fading into black. Quiet, technical, a little dangerous." },
    { key: "brown",  tag: "brown belt",  name: "Brown",  rank: "#7a4a2b", bar: "#111111", text: "#c27b4b", line: "Sharpen everything. Waste nothing.", time: "1–2 years", total: "~6–7 years in", copy: "Grey hex camo with bronze-brown inserts. Built for the grind sessions." },
    { key: "black",  tag: "black belt",  name: "Black",  rank: "#151515", bar: "#c8102e", text: "#eeeae2", line: "A white belt who never quit.", time: "A lifetime", total: "~8–10 years in", copy: "Stealth night camo on a black chassis. Nothing to prove — just mat time." },
  ];
  const paintBelt = (el, b) => { el.style.setProperty("--belt", b.rank === "#151515" ? "#1a1a1a" : b.rank); el.style.setProperty("--bar", b.bar); };

  function initRanked() {
    const products = readJSON("ranked-data"); if (!products || !$("#path")) return;
    BELTS.forEach((b) => {
      const p = products.find((x) => x.tags.map((t) => t.toLowerCase()).includes(b.tag));
      b.product = p || null;
      if (p) {
        b.design = (p.title.split("—")[1] || p.title).trim();
        b.ibjjf = p.tags.map((t) => t.toLowerCase()).includes("ibjjf format");
        const find = (re) => (p.images.find((i) => re.test(i.alt)) || {}).src;
        b.kit = p.images[0] && p.images[0].src;
        b.rashLong = find(/long sleeve|rash guard$/) || find(/rash guard/);
        b.rashShort = find(/short sleeve/) || find(/rash guard/);
        b.rash = b.rashLong || b.rashShort || b.kit;
        b.shorts = find(/shorts/); b.spats = find(/spats/);
        b.sizes = [...new Set(p.variants.map((v) => v.options[v.options.length - 1]))];
      }
    });
    const belts = BELTS.filter((b) => b.product);
    if (!belts.length) return;

    /* hero stack */
    const stack = $("#hero-stack"), heroBelt = $("#hero-belt"), heroLabel = $("#hero-belt-label");
    if (stack) {
      stack.innerHTML = belts.map((b) => `<figure class="stack__card"><img src="${b.kit}" alt=""><figcaption class="mono">${b.name} · ${b.design}</figcaption></figure>`).join("");
      const cards = $$(".stack__card", stack); let i = 0;
      const show = () => {
        const b = belts[i % belts.length];
        cards.forEach((c, k) => { const pos = (k - (i % belts.length) + belts.length) % belts.length; c.style.setProperty("--pos", pos); c.classList.toggle("is-front", pos === 0); });
        paintBelt(heroBelt, b); heroLabel.textContent = `${b.name} belt · ${b.design}`;
        heroBelt.classList.remove("is-striped"); void heroBelt.offsetWidth; setTimeout(() => heroBelt.classList.add("is-striped"), 350);
        i++;
      };
      show(); if (!reduceMotion) setInterval(show, 2800);
      stack.addEventListener("click", () => document.getElementById("ranked").scrollIntoView());
    }

    /* buy box */
    const state = { belt: belts[Math.min(1, belts.length - 1)], size: "M" };
    const variantFor = () => state.belt.product.variants.find((v) => v.options[v.options.length - 1] === state.size);
    const radio = (name, value, label, checked, extra = "") => `<label><input type="radio" name="${name}" value="${value}" ${checked ? "checked" : ""}><span ${extra}>${label}</span></label>`;
    let mainSrc = null;
    const renderBox = () => {
      const b = state.belt;
      const sizes = b.sizes; if (!sizes.includes(state.size)) state.size = sizes[0];
      $("#belt-chips").innerHTML = `<legend class="mono">Rank</legend>` + belts.map((x) => radio("belt", x.key, x.name, x === b, `style="--swatch:${x.rank}"`)).join("");
      $("#size-chips").innerHTML = `<legend class="mono">Size <a href="/pages/size-guide" class="sizehelp">Size guide</a></legend>` + sizes.map((s) => radio("size", s, s, s === state.size)).join("");
      const v = variantFor();
      $("#ranked-belt").textContent = b.name; $("#ranked-design").textContent = b.design;
      $("#ranked-copy").textContent = b.copy;
      $("#ranked-price").textContent = v ? money(v.price) : "—";
      const add = $("#ranked-add"); add.disabled = !v || !v.available; add.textContent = v ? (v.available ? "Add rash guard to cart" : "Sold out") : "Unavailable";
      $("#legal").textContent = b.ibjjf ? "IBJJF no-gi format ✓" : "Training cut"; $("#legal").classList.toggle("is-train", !b.ibjjf);
      const pics = b.product.images.map((i, k) => [i.alt || `photo ${k + 1}`, i.src]);
      if (!mainSrc || !pics.some((x) => x[1] === mainSrc)) mainSrc = pics[0] && pics[0][1];
      $("#g-main").src = mainSrc; $("#g-main").alt = `${b.name} belt ${b.design}`;
      $("#g-thumbs").innerHTML = pics.map(([k, src]) => `<button type="button" class="thumb ${src === mainSrc ? "is-active" : ""}" data-src="${src}" aria-label="${k}"><img src="${src}" alt=""></button>`).join("");
      const sticky = $("#sticky-label"); if (sticky) sticky.textContent = `${b.name} belt rash guard · ${v ? money(v.price) : ""}`;
    };
    $("#ranked").addEventListener("change", (e) => {
      const t = e.target;
      if (t.name === "belt") { state.belt = belts.find((x) => x.key === t.value); mainSrc = null; }
      if (t.name === "size") state.size = t.value;
      renderBox();
    });
    $("#g-thumbs").addEventListener("click", (e) => { const t = e.target.closest(".thumb"); if (t) { mainSrc = t.dataset.src; renderBox(); } });
    $("#ranked-add").addEventListener("click", async () => {
      const v = variantFor(); if (!v) return;
      const add = $("#ranked-add"); add.disabled = true;
      await addItems([{ id: v.id, quantity: 1 }], `${state.belt.name} ${state.belt.design} rash guard · ${state.size}`);
      add.disabled = false;
    });
    renderBox();
    const selectRank = (key) => { const b = belts.find((x) => x.key === key); if (b) { state.belt = b; mainSrc = null; renderBox(); } };

    /* lineup */
    $("#lineup-grid").innerHTML = belts.map((b) => `
<article class="lineup__card reveal" style="--rank:${b.key === "black" ? "#c8102e" : b.rank}">
  <button type="button" class="lineup__media" data-belt="${b.key}" aria-label="Choose ${b.name} belt rash guard"><img src="${b.kit}" alt="${b.name} belt ${b.design} rash guard" loading="lazy"></button>
  <div class="lineup__body">
    <p class="mono"><span class="swatch" style="background:${b.rank}"></span>${b.name} belt</p>
    <h3>${b.design}</h3>
    <p class="lineup__price mono">From ${money(Math.min(...b.product.variants.map((v) => v.price)))}</p>
    <button type="button" class="btn btn--sm btn--line-dark btn--block" data-belt="${b.key}">Choose ${b.name.toLowerCase()}</button>
  </div>
</article>`).join("");
    $("#lineup-grid").addEventListener("click", (e) => { const x = e.target.closest("[data-belt]"); if (x) { selectRank(x.dataset.belt); document.getElementById("ranked").scrollIntoView(); } });

    /* path */
    const section = $("#path"), beltsWrap = $("#path-belts");
    belts.forEach((b) => { const el = document.createElement("div"); el.className = "belt"; el.innerHTML = '<span class="belt__bar"><i></i><i></i><i></i><i></i></span>'; paintBelt(el, b); beltsWrap.appendChild(el); const im = new Image(); im.src = b.rash; });
    const beltEls = [...beltsWrap.children];
    const big = $("#path-bigbelt"), steps = $("#path-steps"), promo = $("#path-promo"), hint = $("#path-hint"), hud = $("#hud-stripes");
    steps.innerHTML = belts.map((b) => `<li style="--c:${b.key === "black" ? "#c8102e" : b.rank}"><span></span>${b.name}</li>`).join("");
    const stepEls = [...steps.children];
    const nameEl = $("#path-belt"), cta = $("#path-cta"), bar = $("#path-progress"), sticky = $(".path__sticky"), photo = $("#path-photo"), img = $("#path-img"), cap = $("#path-cap");
    const N = belts.length; let current = -1, promoTimer;
    const setStage = (s) => {
      const b = belts[s];
      if (current !== -1 && s > current) {
        promo.innerHTML = `<span class="mono">Promoted</span><strong style="color:${b.text}">${b.name} belt</strong>`;
        promo.classList.remove("is-on"); void promo.offsetWidth; promo.classList.add("is-on");
        clearTimeout(promoTimer); promoTimer = setTimeout(() => promo.classList.remove("is-on"), 1400);
      }
      current = s;
      paintBelt(big, b);
      stepEls.forEach((li, i) => { li.classList.toggle("is-active", i === s); li.classList.toggle("is-done", i < s); });
      nameEl.textContent = b.name; nameEl.style.color = b.text;
      nameEl.classList.remove("swap"); void nameEl.offsetWidth; nameEl.classList.add("swap");
      $("#path-line").textContent = b.line; $("#path-time").textContent = b.time; $("#path-total").textContent = b.total;
      $("#path-step").textContent = String(s + 1).padStart(2, "0");
      cta.textContent = `Wear your ${b.name.toLowerCase()}`; cta.dataset.belt = b.key;
      img.src = b.rash; img.alt = `${b.name} belt ${b.design} rash guard`; cap.textContent = `${b.name} · ${b.design}`;
      photo.style.setProperty("--tilt", `${s % 2 ? 3 : -3}deg`);
      photo.classList.remove("swap"); void photo.offsetWidth; photo.classList.add("swap");
      sticky.style.setProperty("--belt", b.key === "black" ? "#c8102e" : b.rank);
    };
    const onScroll = () => {
      const total = section.offsetHeight - window.innerHeight;
      const p = Math.min(1, Math.max(0, -section.getBoundingClientRect().top / total));
      const raw = Math.min(N - 0.001, p * N), stage = Math.floor(raw), stripes = Math.floor((raw - stage) * 5);
      if (stage !== current) setStage(stage);
      beltEls.forEach((el, idx) => {
        el.classList.toggle("is-active", idx === stage); el.classList.toggle("is-done", idx < stage);
        $$("i", el).forEach((st, k) => { st.style.transform = (idx < stage || (idx === stage && k < stripes)) ? "scaleY(1)" : "scaleY(0)"; });
      });
      $$("i", big).forEach((st, k) => { st.style.transform = k < stripes ? "scaleY(1)" : "scaleY(0)"; });
      hud.textContent = stage === N - 1 && stripes === 4 ? `${belts[N - 1].name} belt · 4 stripes` : `${stripes} / 4 stripes`;
      hint.classList.toggle("is-hidden", p > 0.02);
      bar.style.width = `${p * 100}%`;
    };
    window.addEventListener("scroll", onScroll, { passive: true }); window.addEventListener("resize", onScroll); onScroll();
    cta.addEventListener("click", () => selectRank(cta.dataset.belt));

    /* sticky add-to-cart (phones): hidden over the path and the buy box */
    const st = $("#sticky-atc"), box = $("#ranked"); let boxVisible = false;
    const stick = () => { const r = section.getBoundingClientRect(); const inPath = r.top < window.innerHeight && r.bottom > 0; st.classList.toggle("is-visible", window.scrollY > window.innerHeight && !boxVisible && !inPath); };
    new IntersectionObserver(([e]) => { boxVisible = e.isIntersecting; stick(); }, { threshold: 0.15 }).observe(box);
    window.addEventListener("scroll", stick, { passive: true });
  }

  initChrome();
  initDesigns();
  initBuilder();
  initProduct();
  initRanked();
  initReveal();
})();
